import { z } from "zod";

export const sourceLinkSchema = z.object({
  id: z.string().optional(),
  platform: z.string(),
  url: z.string(),
  label: z.string().nullable().optional(),
  isOfficial: z.boolean(),
});
export const tagSchema = z.object({ id: z.string(), name: z.string() });
export const officialBadgeSchema = z.object({
  type: z.string(), label: z.string(), displayName: z.string(),
  verifiedAt: z.string().nullable().optional(),
});
export const businessHourSchema = z.object({
  dayOfWeek: z.number(),
  opensAt: z.string().nullable().optional(),
  closesAt: z.string().nullable().optional(),
  isClosed: z.boolean(),
});

export const placeSchema = z.object({
  id: z.string(),
  name: z.string(),
  description: z.string().nullable().optional(),
  category: z.object({ id: z.string().optional(), code: z.string(), name: z.string() }),
  location: z.object({
    latitude: z.number(), longitude: z.number(),
    addressLine: z.string(), roadAddress: z.string().nullable().optional(),
  }),
  verificationStatus: z.string(),
  status: z.string(),
  lastVerifiedAt: z.string().nullable().optional(),
  activeEventCount: z.number(),
  sourceLinks: z.array(sourceLinkSchema).default([]),
  officialBadge: officialBadgeSchema.nullable().optional(),
  tags: z.array(tagSchema).default([]),
  paymentMethods: z.array(z.string()).optional(),
  photographyPolicy: z.string().nullable().optional(),
  accessibilityInfo: z.string().nullable().optional(),
  reservationInfo: z.string().nullable().optional(),
  businessHours: z.array(businessHourSchema).optional(),
  isFavorited: z.boolean().optional(),
});

/**
 * GET /map/items 실측 응답 키 (09_API_CONTRACT §4.3).
 * timezone 은 서버가 보내지 않으므로 넣지 않는다 (OD-019).
 * hasVisited 는 서버가 안 보내므로 optional 이다 (AC-10 교정).
 */
export const mapMarkerSchema = z.object({
  id: z.string(),
  targetType: z.enum(["PLACE", "EVENT"]).optional(),
  placeId: z.string().optional(),
  eventId: z.string().optional(),
  name: z.string(),
  addressLine: z.string().optional(),
  categoryCode: z.string(),
  latitude: z.number(),
  longitude: z.number(),
  activeEventCount: z.number(),
  verificationStatus: z.string(),
  placeStatus: z.string(),
  isFavorited: z.boolean(),
  hasVisited: z.boolean().optional(),
  distanceMeters: z.number().optional(),
  status: z.string().optional(),
  startsAt: z.string().optional(),
  endsAt: z.string().optional(),
});
export type MapMarkerDto = z.infer<typeof mapMarkerSchema>;
export type PlaceDto = z.infer<typeof placeSchema>;
